// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const StudentEnquiries = () => {
//   const [enquiries, setEnquiries] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Search State
//   const [searchTerm, setSearchTerm] = useState('');

//   // Pagination States
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 6;

//   // Base API URL
//   const API_URL = 'https://metapi.emedhatechnologies.com/api/students/student-enquiries';

//   useEffect(() => {
//     fetchEnquiries();
//   }, []);

//   const fetchEnquiries = async () => {
//     try {
//       const response = await axios.get(API_URL);
//       if (response.data.success) {
//         setEnquiries(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching student enquiries:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSendAction = (student) => {
//     alert(`Triggering action/message for: ${student.student_name} (${student.email_address})`);
//   };

//   // Filter Logic based on Search Term
//   const filteredEnquiries = enquiries.filter((item) => {
//     const term = searchTerm.toLowerCase();
//     const name = item.student_name ? item.student_name.toLowerCase() : '';
//     const email = item.email_address ? item.email_address.toLowerCase() : '';
//     const mobile = item.mobile_number ? item.mobile_number.toString().toLowerCase() : '';
//     const program = item.program_interested ? item.program_interested.toLowerCase() : '';

//     return name.includes(term) || email.includes(term) || mobile.includes(term) || program.includes(term);
//   });

//   // Pagination Logic (applied on filtered results)
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentEnquiries = filteredEnquiries.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredEnquiries.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   // Reset to page 1 whenever search query changes
//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   return (
//     <div style={styles.container}>
//       {/* Header Section */}
//       <div style={styles.headerContainer}>
//         <div>
//           <h2 style={styles.title}>Student Enquiries</h2>
//           <p style={styles.subtitle}>Manage incoming candidate questions and track applications.</p>
//         </div>
//         <span style={styles.counterBadge}>
//           <svg style={styles.iconSm} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle></svg>
//           Total: {filteredEnquiries.length} {filteredEnquiries.length !== enquiries.length ? `(filtered from ${enquiries.length})` : ''}
//         </span>
//       </div>

//       {/* Search Bar Section */}
//       <div style={styles.searchBarContainer}>
//         <div style={styles.searchInputWrapper}>
//           <svg style={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="11" cy="11" r="8"></circle>
//             <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
//           </svg>
//           <input
//             type="text"
//             placeholder="Search by name, email, phone, or program..."
//             value={searchTerm}
//             onChange={handleSearchChange}
//             style={styles.searchInput}
//           />
//           {searchTerm && (
//             <button onClick={() => { setSearchTerm(''); setCurrentPage(1); }} style={styles.clearSearchBtn}>
//               Clear
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Main Table Container */}
//       <div style={styles.card}>
//         {loading ? (
//           <div style={styles.loadingContainer}>
//             <div style={styles.spinner}></div>
//             <p style={styles.loadingText}>Loading enquiries...</p>
//           </div>
//         ) : (
//           <>
//             <div style={styles.tableWrapper}>
//               <table style={styles.table}>
//                 <thead>
//                   <tr style={styles.trHead}>
//                     <th style={styles.th}>Student</th>
//                     <th style={styles.th}>Contact</th>
//                     <th style={styles.th}>Program / Qual.</th>
//                     <th style={styles.th}>Location</th>
//                     <th style={styles.th}>Working</th>
//                     <th style={styles.th}>Date</th>
//                     <th style={{ ...styles.th, textAlign: 'center' }}>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentEnquiries.length > 0 ? (
//                     currentEnquiries.map((item, index) => (
//                       <tr key={item.id} style={index % 2 === 0 ? styles.trEven : styles.trOdd}>
//                         {/* Student Info */}
//                         <td style={styles.td}>
//                           <div style={styles.profileCell}>
//                             <div style={styles.avatar}>{item.student_name ? item.student_name.charAt(0).toUpperCase() : 'S'}</div>
//                             <div>
//                               <div style={styles.studentName}>{item.student_name}</div>
//                             </div>
//                           </div>
//                         </td>

//                         {/* Contact */}
//                         <td style={styles.td}>
//                           <div style={styles.contactStack}>
//                             <span style={styles.contactText}>
//                               <svg style={styles.iconXs} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
//                               {item.email_address}
//                             </span>
//                             <span style={styles.contactText}>
//                               <svg style={styles.iconXs} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
//                               {item.mobile_number}
//                             </span>
//                           </div>
//                         </td>

//                         {/* Program & Qual */}
//                         <td style={styles.td}>
//                           <div style={styles.programStack}>
//                             <span style={styles.programText}>{item.program_interested}</span>
//                             <span style={styles.tagQual}>{item.highest_qualification || 'N/A'}</span>
//                           </div>
//                         </td>

//                         {/* Location */}
//                         <td style={styles.td}>
//                           <span style={styles.locationText}>
//                             <svg style={styles.iconXs} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
//                             {item.city ? `${item.city}, ` : ''}{item.state}
//                           </span>
//                         </td>

//                         {/* Working Professional */}
//                         <td style={styles.td}><span style={{ ...styles.statusPill, background: item.is_working_professional?.toLowerCase() === 'yes' ? '#e6f4ea' : '#f1f3f4', color: item.is_working_professional?.toLowerCase() === 'yes' ? '#137333' : '#5f6368' }}>{item.is_working_professional || 'No'}</span></td>

//                         {/* Date */}
//                         <td style={styles.td}><span style={styles.dateText}>{item.created_at}</span></td>

//                         {/* Action */}
//                         <td style={{ ...styles.td, textAlign: 'center' }}>
//                           <button onClick={() => handleSendAction(item)} style={styles.actionBtn} title="Send Message">
//                             <svg style={styles.iconSm} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>Send</button>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="7" style={styles.emptyState}>No matching student enquiries found.</td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination Bar */}
//             {filteredEnquiries.length > 0 && (
//               <div style={styles.paginationContainer}>
//                 <span style={styles.paginationInfo}>Showing <b>{indexOfFirstItem + 1}</b> to <b>{Math.min(indexOfLastItem, filteredEnquiries.length)}</b> of <b>{filteredEnquiries.length}</b> entries</span>

//                 <div style={styles.paginationControls}>
//                   <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} style={{ ...styles.pageBtn, opacity: currentPage === 1 ? 0.4 : 1 }}>Previous</button>
//                   <span style={styles.pageIndicator}>Page {currentPage} of {totalPages || 1}</span>
//                   <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0} style={{ ...styles.pageBtn, opacity: (currentPage === totalPages || totalPages === 0) ? 0.4 : 1 }}>Next</button>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// // Stylesheet
// const styles = {
//   container: { backgroundColor: '#f8fafc', minHeight: '100vh', fontFamily: '"Inter", system-ui, -apple-system, sans-serif', color: '#1e293b' },
//   headerContainer: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
//   title: { fontSize: '22px', fontWeight: '700', color: '#0f172a', margin: '0 0 4px 0' },
//   subtitle: { fontSize: '13px', color: '#64748b', margin: 0 },
//   counterBadge: { display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#ffffff', color: '#334155', padding: '6px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: '600', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' },

//   // Search Styles
//   searchBarContainer: { marginBottom: '16px' },
//   searchInputWrapper: { position: 'relative', display: 'flex', alignItems: 'center', background: '#ffffff', border: '1px solid #cbd5e1', borderRadius: '8px', padding: '0 12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' },
//   searchIcon: { width: '16px', height: '16px', strokeWidth: 2, color: '#94a3b8', marginRight: '8px', flexShrink: 0 },
//   searchInput: { width: '100%', border: 'none', outline: 'none', padding: '10px 0', fontSize: '13px', color: '#1e293b', background: 'transparent' },
//   clearSearchBtn: { background: 'transparent', border: 'none', color: '#64748b', fontSize: '12px', cursor: 'pointer', fontWeight: '500', padding: '2px 6px', borderRadius: '4px' },

//   card: { background: '#ffffff', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0', overflow: 'hidden' },
//   tableWrapper: { width: '100%' },
//   table: { width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '13px' },
//   trHead: { backgroundColor: '#f1f5f9', borderBottom: '1px solid #e2e8f0' },
//   th: { padding: '12px 14px', color: '#475569', fontWeight: '600', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.04em' },
//   trEven: { backgroundColor: '#ffffff' },
//   trOdd: { backgroundColor: '#fafbfc' },
//   td: { padding: '12px 14px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'middle', color: '#334155' },
//   profileCell: { display: 'flex', alignItems: 'center', gap: '10px' },
//   avatar: { width: '32px', height: '32px', borderRadius: '8px', background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '13px', flexShrink: 0 },
//   studentName: { fontWeight: '600', color: '#0f172a', fontSize: '13px' },
//   contactStack: { display: 'flex', flexDirection: 'column', gap: '3px' },
//   contactText: { display: 'inline-flex', alignItems: 'center', gap: '5px', color: '#64748b', fontSize: '12px' },
//   programStack: { display: 'flex', flexDirection: 'column', gap: '3px' },
//   programText: { fontWeight: '500', color: '#0f172a', fontSize: '13px' },
//   tagQual: { background: '#eff6ff', color: '#1e40af', padding: '2px 6px', borderRadius: '4px', fontSize: '11px', width: 'fit-content', fontWeight: '500' },
//   locationText: { display: 'inline-flex', alignItems: 'center', gap: '4px', color: '#64748b', fontSize: '12px' },
//   statusPill: { padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600', display: 'inline-block' },
//   dateText: { color: '#64748b', fontSize: '12px', whiteSpace: 'nowrap' },
//   actionBtn: { background: '#2563eb', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '4px', fontWeight: '500', fontSize: '12px' },
//   paginationContainer: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px', borderTop: '1px solid #e2e8f0', backgroundColor: '#fafafa' },
//   paginationInfo: { fontSize: '12px', color: '#64748b' },
//   paginationControls: { display: 'flex', alignItems: 'center', gap: '10px' },
//   pageBtn: { backgroundColor: '#ffffff', border: '1px solid #cbd5e1', color: '#334155', padding: '5px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: '500', cursor: 'pointer' },
//   pageIndicator: { fontSize: '12px', fontWeight: '600', color: '#475569' },
//   iconSm: { width: '14px', height: '14px', strokeWidth: 2 },
//   iconXs: { width: '12px', height: '12px', strokeWidth: 2, color: '#94a3b8', flexShrink: 0 },
//   loadingContainer: { padding: '40px', textAlign: 'center' },
//   spinner: { width: '28px', height: '28px', border: '3px solid #e2e8f0', borderTop: '3px solid #2563eb', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 12px auto' },
//   loadingText: { color: '#64748b', fontSize: '13px', margin: 0 },
//   emptyState: { textAlign: 'center', padding: '36px', color: '#64748b', fontSize: '13px' }
// };

// export default StudentEnquiries;

import React, { useState, useEffect } from 'react';
import axios from 'axios';

const StudentEnquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [counsellors, setCounsellors] = useState([]);
  const [loading, setLoading] = useState(true);

  // Search & Pagination States
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Bulk & Single Conversion Modal States
  const [selectedEnquiryIds, setSelectedEnquiryIds] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCounsellor, setSelectedCounsellor] = useState('');
  const [submittingConversion, setSubmittingConversion] = useState(false);

  // Base API URLs
  const API_ENQUIRIES = 'https://metapi.emedhatechnologies.com/api/students/student-enquiries';
  const API_COUNSELLORS = 'https://metapi.emedhatechnologies.com/api/students/staff/counsellors';
  const API_CONVERT_LEAD = 'https://metapi.emedhatechnologies.com/api/students/students/convert-lead';

  useEffect(() => {
    fetchEnquiries();
    fetchCounsellors();
  }, []);

  const fetchEnquiries = async () => {
    try {
      const response = await axios.get(API_ENQUIRIES);
      if (response.data.success) {
        setEnquiries(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching student enquiries:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCounsellors = async () => {
    try {
      const response = await axios.get(API_COUNSELLORS);
      if (response.data.success) {
        setCounsellors(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching counsellors:', error);
    }
  };

  // Checkbox Selection Handlers
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const currentUnconvertedIds = currentEnquiries
        .filter(item => !item.is_converted_to_lead)
        .map(item => item.id);
      setSelectedEnquiryIds(currentUnconvertedIds);
    } else {
      setSelectedEnquiryIds([]);
    }
  };

  const handleSelectOne = (id) => {
    if (selectedEnquiryIds.includes(id)) {
      setSelectedEnquiryIds(selectedEnquiryIds.filter(item => item !== id));
    } else {
      setSelectedEnquiryIds([...selectedEnquiryIds, id]);
    }
  };

  // Open Conversion Modal for Single Row or Bulk Selection
  const handleOpenConversionModal = (singleId = null) => {
    if (singleId) {
      setSelectedEnquiryIds([singleId]);
    }
    if (selectedEnquiryIds.length === 0 && !singleId) {
      alert('Please select at least one enquiry to convert.');
      return;
    }
    setIsModalOpen(true);
  };

  // Submit Lead Conversion to Express API
  const handleConfirmLeadConversion = async () => {
    if (!selectedCounsellor) {
      alert('Please select a counsellor to assign these enquiries.');
      return;
    }

    const counsellorObj = counsellors.find(c => c.id.toString() === selectedCounsellor.toString());

    setSubmittingConversion(true);

    try {
      const payload = {
        enquiryIds: selectedEnquiryIds,
        counsellorId: counsellorObj.id,
        counsellorName: counsellorObj.name,
        counsellorRole: counsellorObj.role || 'counsellor'
      };

      const response = await axios.post(API_CONVERT_LEAD, payload);

      if (response.data.success) {
        alert(response.data.message);
        setIsModalOpen(false);
        setSelectedEnquiryIds([]);
        setSelectedCounsellor('');
        fetchEnquiries(); // Refresh table data
      }
    } catch (error) {
      console.error('Error converting lead:', error);
      alert('Failed to convert enquiries to leads. Please try again.');
    } finally {
      setSubmittingConversion(false);
    }
  };

  // Filter Logic
  const filteredEnquiries = enquiries.filter((item) => {
    const term = searchTerm.toLowerCase();
    const name = item.student_name ? item.student_name.toLowerCase() : '';
    const email = item.email_address ? item.email_address.toLowerCase() : '';
    const mobile = item.mobile_number ? item.mobile_number.toString().toLowerCase() : '';
    const program = item.program_interested ? item.program_interested.toLowerCase() : '';

    return name.includes(term) || email.includes(term) || mobile.includes(term) || program.includes(term);
  });

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentEnquiries = filteredEnquiries.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredEnquiries.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
    setSelectedEnquiryIds([]);
  };

  return (
    <div style={styles.container}>
      
      {/* Header Section */}
      <div style={styles.headerContainer}>
        <div>
          <h2 style={styles.title}>Student Enquiries</h2>
          <p style={styles.subtitle}>Manage incoming candidate questions and convert them to active CRM leads.</p>
        </div>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          {selectedEnquiryIds.length > 0 && (
            <button 
              onClick={() => handleOpenConversionModal()} 
              style={styles.bulkConvertBtn}
            >
              Convert Selected ({selectedEnquiryIds.length}) to Lead
            </button>
          )}
          <span style={styles.counterBadge}>
            Total: {filteredEnquiries.length} {filteredEnquiries.length !== enquiries.length ? `(filtered from ${enquiries.length})` : ''}
          </span>
        </div>
      </div>

      {/* Search Bar Section */}
      <div style={styles.searchBarContainer}>
        <div style={styles.searchInputWrapper}>
          <svg style={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input
            type="text"
            placeholder="Search by name, email, phone, or program..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={styles.searchInput}
          />
          {searchTerm && (
            <button onClick={() => { setSearchTerm(''); setCurrentPage(1); }} style={styles.clearSearchBtn}>
              Clear
            </button>
          )}
        </div>
      </div>

      {/* Main Table Container */}
      <div style={styles.card}>
        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.spinner}></div>
            <p style={styles.loadingText}>Loading enquiries...</p>
          </div>
        ) : (
          <>
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.trHead}>
                    <th style={{ ...styles.th, width: '40px' }}>
                      <input 
                        type="checkbox" 
                        onChange={handleSelectAll} 
                        checked={
                          currentEnquiries.length > 0 &&
                          currentEnquiries
                            .filter(i => !i.is_converted_to_lead)
                            .every(i => selectedEnquiryIds.includes(i.id))
                        }
                      />
                    </th>
                    <th style={styles.th}>Student</th>
                    <th style={styles.th}>Contact</th>
                    <th style={styles.th}>Program / Qual.</th>
                    <th style={styles.th}>Location</th>
                    <th style={styles.th}>Working</th>
                    <th style={styles.th}>Converted</th>
                    <th style={{ ...styles.th, textAlign: 'center' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentEnquiries.length > 0 ? (
                    currentEnquiries.map((item, index) => {
                      const isConverted = Boolean(item.is_converted_to_lead);
                      const isSelected = selectedEnquiryIds.includes(item.id);

                      return (
                        <tr key={item.id} style={index % 2 === 0 ? styles.trEven : styles.trOdd}>
                          
                          {/* Bulk Checkbox */}
                          <td style={styles.td}>
                            <input
                              type="checkbox"
                              disabled={isConverted}
                              checked={isSelected}
                              onChange={() => handleSelectOne(item.id)}
                            />
                          </td>

                          {/* Student Info */}
                          <td style={styles.td}>
                            <div style={styles.profileCell}>
                              <div style={styles.avatar}>
                                {item.student_name ? item.student_name.charAt(0).toUpperCase() : 'S'}
                              </div>
                              <div>
                                <div style={styles.studentName}>{item.student_name}</div>
                              </div>
                            </div>
                          </td>

                          {/* Contact */}
                          <td style={styles.td}>
                            <div style={styles.contactStack}>
                              <span style={styles.contactText}>{item.email_address}</span>
                              <span style={styles.contactText}>{item.mobile_number}</span>
                            </div>
                          </td>

                          {/* Program & Qualification */}
                          <td style={styles.td}>
                            <div style={styles.programStack}>
                              <span style={styles.programText}>{item.program_interested}</span>
                              <span style={styles.tagQual}>{item.highest_qualification || 'N/A'}</span>
                            </div>
                          </td>

                          {/* Location */}
                          <td style={styles.td}>
                            <span style={styles.locationText}>
                              {item.city ? `${item.city}, ` : ''}{item.state}
                            </span>
                          </td>

                          {/* Working Professional */}
                          <td style={styles.td}>
                            <span style={{ 
                              ...styles.statusPill, 
                              background: item.is_working_professional?.toLowerCase() === 'yes' ? '#e6f4ea' : '#f1f3f4', 
                              color: item.is_working_professional?.toLowerCase() === 'yes' ? '#137333' : '#5f6368' 
                            }}>
                              {item.is_working_professional || 'No'}
                            </span>
                          </td>

                          {/* Converted Status */}
                          <td style={styles.td}>
                            <span style={{
                              ...styles.statusPill,
                              background: isConverted ? '#dcfce7' : '#fef3c7',
                              color: isConverted ? '#15803d' : '#b45309'
                            }}>
                              {isConverted ? 'Converted' : 'Pending'}
                            </span>
                          </td>

                          {/* Action Button */}
                          <td style={{ ...styles.td, textAlign: 'center' }}>
                            {isConverted ? (
                              <span style={{ fontSize: '11px', color: '#16a34a', fontWeight: '600' }}>✓ Lead Created</span>
                            ) : (
                              <button 
                                onClick={() => handleOpenConversionModal(item.id)} 
                                style={styles.actionBtn}
                              >
                                Convert to Lead
                              </button>
                            )}
                          </td>

                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" style={styles.emptyState}>No matching student enquiries found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Bar */}
            {filteredEnquiries.length > 0 && (
              <div style={styles.paginationContainer}>
                <span style={styles.paginationInfo}>
                  Showing <b>{indexOfFirstItem + 1}</b> to <b>{Math.min(indexOfLastItem, filteredEnquiries.length)}</b> of <b>{filteredEnquiries.length}</b> entries
                </span>

                <div style={styles.paginationControls}>
                  <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} style={{ ...styles.pageBtn, opacity: currentPage === 1 ? 0.4 : 1 }}>Previous</button>
                  <span style={styles.pageIndicator}>Page {currentPage} of {totalPages || 1}</span>
                  <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0} style={{ ...styles.pageBtn, opacity: (currentPage === totalPages || totalPages === 0) ? 0.4 : 1 }}>Next</button>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* COUNSELLOR ASSIGNMENT MODAL */}
      {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h3 style={styles.modalTitle}>Assign Counsellor &amp; Convert to Lead</h3>
            <p style={styles.modalDesc}>
              Converting <b>{selectedEnquiryIds.length}</b> enquiry record(s) to <b>academy_leads</b> table.
            </p>

            <div style={{ marginBottom: '16px' }}>
              <label style={styles.modalLabel}>Select Counsellor *</label>
              <select
                value={selectedCounsellor}
                onChange={(e) => setSelectedCounsellor(e.target.value)}
                style={styles.modalSelect}
              >
                <option value="">-- Choose Counsellor --</option>
                {counsellors.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name} ({c.role})
                  </option>
                ))}
              </select>
            </div>

            <div style={styles.modalActions}>
              <button 
                onClick={() => { setIsModalOpen(false); setSelectedEnquiryIds([]); }} 
                style={styles.cancelBtn}
                disabled={submittingConversion}
              >
                Cancel
              </button>
              <button 
                onClick={handleConfirmLeadConversion} 
                style={styles.confirmBtn}
                disabled={submittingConversion}
              >
                {submittingConversion ? 'Converting...' : 'Confirm Conversion'}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

// CSS Styles
const styles = {
  container: { backgroundColor: '#f8fafc', minHeight: '100vh', fontFamily: '"Inter", system-ui, sans-serif', color: '#1e293b', padding: '20px' },
  headerContainer: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
  title: { fontSize: '22px', fontWeight: '700', color: '#0f172a', margin: '0 0 4px 0' },
  subtitle: { fontSize: '13px', color: '#64748b', margin: 0 },
  counterBadge: { display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#ffffff', color: '#334155', padding: '6px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: '600', border: '1px solid #e2e8f0' },
  bulkConvertBtn: { backgroundColor: '#15803d', color: '#ffffff', border: 'none', padding: '8px 14px', borderRadius: '6px', fontWeight: '700', fontSize: '12px', cursor: 'pointer' },

  searchBarContainer: { marginBottom: '16px' },
  searchInputWrapper: { position: 'relative', display: 'flex', alignItems: 'center', background: '#ffffff', border: '1px solid #cbd5e1', borderRadius: '8px', padding: '0 12px' },
  searchIcon: { width: '16px', height: '16px', strokeWidth: 2, color: '#94a3b8', marginRight: '8px' },
  searchInput: { width: '100%', border: 'none', outline: 'none', padding: '10px 0', fontSize: '13px', color: '#1e293b', background: 'transparent' },
  clearSearchBtn: { background: 'transparent', border: 'none', color: '#64748b', fontSize: '12px', cursor: 'pointer', fontWeight: '500' },

  card: { background: '#ffffff', borderRadius: '12px', border: '1px solid #e2e8f0', overflow: 'hidden' },
  tableWrapper: { width: '100%' },
  table: { width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '13px' },
  trHead: { backgroundColor: '#f1f5f9', borderBottom: '1px solid #e2e8f0' },
  th: { padding: '12px 14px', color: '#475569', fontWeight: '600', fontSize: '11px', textTransform: 'uppercase' },
  trEven: { backgroundColor: '#ffffff' },
  trOdd: { backgroundColor: '#fafbfc' },
  td: { padding: '12px 14px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'middle', color: '#334155' },
  profileCell: { display: 'flex', alignItems: 'center', gap: '10px' },
  avatar: { width: '32px', height: '32px', borderRadius: '8px', background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '13px' },
  studentName: { fontWeight: '600', color: '#0f172a', fontSize: '13px' },
  contactStack: { display: 'flex', flexDirection: 'column', gap: '3px' },
  contactText: { color: '#64748b', fontSize: '12px' },
  programStack: { display: 'flex', flexDirection: 'column', gap: '3px' },
  programText: { fontWeight: '500', color: '#0f172a', fontSize: '13px' },
  tagQual: { background: '#eff6ff', color: '#1e40af', padding: '2px 6px', borderRadius: '4px', fontSize: '11px', width: 'fit-content' },
  locationText: { color: '#64748b', fontSize: '12px' },
  statusPill: { padding: '3px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600', display: 'inline-block' },
  actionBtn: { background: '#2563eb', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '12px' },
  paginationContainer: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px', borderTop: '1px solid #e2e8f0', backgroundColor: '#fafafa' },
  paginationInfo: { fontSize: '12px', color: '#64748b' },
  paginationControls: { display: 'flex', alignItems: 'center', gap: '10px' },
  pageBtn: { backgroundColor: '#ffffff', border: '1px solid #cbd5e1', color: '#334155', padding: '5px 12px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' },
  pageIndicator: { fontSize: '12px', fontWeight: '600', color: '#475569' },
  loadingContainer: { padding: '40px', textAlign: 'center' },
  spinner: { width: '28px', height: '28px', border: '3px solid #e2e8f0', borderTop: '3px solid #2563eb', borderRadius: '50%', margin: '0 auto 12px auto' },
  loadingText: { color: '#64748b', fontSize: '13px' },
  emptyState: { textAlign: 'center', padding: '36px', color: '#64748b', fontSize: '13px' },

  // Modal Styles
  modalOverlay: { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(15, 23, 42, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zindex: 1000 },
  modalBox: { backgroundColor: '#ffffff', width: '100%', maxWidth: '420px', borderRadius: '12px', padding: '24px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' },
  modalTitle: { fontSize: '16px', fontWeight: '700', color: '#0f172a', margin: '0 0 8px 0' },
  modalDesc: { fontSize: '13px', color: '#64748b', margin: '0 0 16px 0' },
  modalLabel: { fontSize: '12px', fontWeight: '600', color: '#334155', display: 'block', marginBottom: '6px' },
  modalSelect: { width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px', outline: 'none' },
  modalActions: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' },
  cancelBtn: { backgroundColor: '#f1f5f9', border: '1px solid #cbd5e1', color: '#475569', padding: '8px 16px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' },
  confirmBtn: { backgroundColor: '#2563eb', border: 'none', color: '#ffffff', padding: '8px 16px', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }
};

export default StudentEnquiries;